import MuiTypography from '@mui/material/Typography';
import styled from 'styled-components';
export const TypographyStyled = styled(MuiTypography).attrs({
    variantMapping: {
        overline: 'p',
        cta: 'p',
        link: 'a',
    },
})(({ theme, color = 'primary', variant, weight, }) => {
    var _a, _b;
    return ({
        color: theme === null || theme === void 0 ? void 0 : theme.palette.text[color],
        ...(variant === 'link') && {
            color: theme === null || theme === void 0 ? void 0 : theme.colors.blue.dark,
            ':hover': {
                color: (_a = theme === null || theme === void 0 ? void 0 : theme.shades) === null || _a === void 0 ? void 0 : _a.black,
            },
            ':disabled': {
                color: (_b = theme === null || theme === void 0 ? void 0 : theme.neutrals) === null || _b === void 0 ? void 0 : _b[500],
            },
        },
        ...weight && {
            light: {
                fontWeight: 300,
            },
            normal: {
                fontWeight: 400,
            },
            medium: {
                fontFamily: 'Maax-Medium',
                fontWeight: 500,
            },
            bold: {
                fontWeight: 700,
            },
        }[weight],
    });
});
//# sourceMappingURL=Typography.styles.js.map